export enum LoyaltyAuthEntryMethod {
  BarcodeScanned = 'barcode-scanned',
  CardNumberManuallyEntered = 'card-number-manually-entered',
  CardNumberProvidedExternally = 'card-number-provided-externally',
  EmailManuallyEntered = 'email-manually-entered',
  EmailAndPasswordManuallyEntered = 'email-and-password-manually-entered',
  EmailAndPhoneNumberManuallyEntered = 'email-and-phone-number-manually-entered',
  EmailAndPhoneNumberProvidedExternally = 'email-and-phone-number-provided-externally',
  PhoneNumberManuallyEntered = 'phone-number-manually-entered',
  PhoneNumberProvidedExternally = 'phone-number-provided-externally',
  RedemptionCodeManuallyEntered = 'redemption-code-manually-entered',
  UnknownManuallyEntered = 'unknown-manually-entered',
  UsernameAndPasswordManuallyEntered = 'username-and-password-manually-entered',
}
